import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    myChatWidget?: {
      load: (config: { assistantId: string; apiKey: string }) => void;
    };
  }
}

const ExpoXTCiscoWebex: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadChatWidget = () => {
      const v = document.createElement('script');
      v.type = "text/javascript";
      v.src = "https://agentivehub.com/production.bundle.min.js";
      v.async = true;
      v.onload = () => {
        if (!document.getElementById('root')) {
          const root = document.createElement('div');
          root.id = 'root';
          document.body.appendChild(root);
        }
        if (window.myChatWidget && typeof window.myChatWidget.load === 'function') {
          try {
            window.myChatWidget.load({
              assistantId: '22166886-aa5c-48de-be64-f460653ff389',
              apiKey: '5e9fc760-d861-45eb-8095-72159f99cdf4',
            });
            setIsLoading(false);
          } catch (err) {
            setError('Failed to initialize chat widget');
            setIsLoading(false);
          }
        } else {
          setError('Chat widget not available');
          setIsLoading(false);
        }
      };
      v.onerror = () => {
        setError('Failed to load chat widget script');
        setIsLoading(false);
      };
      const s = document.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(v, s);
    };

    loadChatWidget();

    return () => {
      // Cleanup function if needed
    };
  }, []);

  if (isLoading) {
    return <div className="chatbot-loading">Loading ExpoXT Cisco Webex chat bot...</div>;
  }

  if (error) {
    return <div className="chatbot-error">{error}</div>;
  }

  return (
    <div>
      <h1>ExpoXT Cisco Webex ChatBot</h1>
      <div id="chatbot-container" className="fullscreen" />
    </div>
  );
};

export default ExpoXTCiscoWebex;